/* global rp$, window */
'use strict';

var THE_SCRIPT = function() {
	const $onReady = require('public/js/lib/on-ready');

	function removeCarFromGarage(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		const target = evt.target;
		const closeIcon = target.closest('.car-close-icon');
		if (!closeIcon) {
			return;
		}
		const carHash = closeIcon.getAttribute('data-car-hash');
		if (!carHash) {
			return;
		}

		closeIcon.classList.add('loading');
		const icon = closeIcon.querySelector('i');
		const spinner = document.createElement('div');
		spinner.className = 'loading-spinner';
		if (icon) {
			icon.appendChild(spinner);
		}

		const currentDataPath = closeIcon.getAttribute('data-path');
		const currentFullPath = window.location.pathname;
		const currentMatch = currentFullPath.match(/^\/v-[^/]+/);
		const currentFirstPathSegment = currentMatch ? currentMatch[0] : currentFullPath;

		let alternativeCarHash = null;
		let alternativeCarPath = null;
		const currentListItem = closeIcon.closest('li');
		if (currentListItem && currentListItem.parentElement) {
			const siblingListItems = currentListItem.parentElement.querySelectorAll('li');

			for (let i = 0; i < siblingListItems.length; i++) {
				const siblingItem = siblingListItems[i];
				const otherCloseIcon = siblingItem.querySelector('.car-close-icon');

				if (!otherCloseIcon) continue;

				const otherCarHash = otherCloseIcon.getAttribute('data-car-hash');
				const otherDataPath = otherCloseIcon.getAttribute('data-path');

				if (otherCarHash !== carHash) {
					alternativeCarHash = otherCarHash;
					const otherMatch = otherDataPath.match(/^\/v-[^/]+/);
					const otherFirstPathSegment = otherMatch ? otherMatch[0] : otherDataPath;
					// Preserve the current page context (e.g., /products) when redirecting to alternative car
					const currentPageContext = currentFullPath.replace(currentFirstPathSegment, '');
					alternativeCarPath = otherFirstPathSegment + currentPageContext;
					break;
				}
			}
		}

		const requestData = { carHash: carHash };
		if (alternativeCarHash) {
			requestData.alternativeCarHash = alternativeCarHash;
		}

		$ajax({
			url: '/ajax/garage/remove-car',
			type: 'POST',
			data: requestData,
			success: function(response) {
				if (typeof response === 'string' && response.includes('<!DOCTYPE html>')) {
					closeIcon.classList.remove('loading');
					const spinner = icon?.querySelector('.loading-spinner');
					if (spinner) {
						spinner.remove();
					}
					return;
				}

				if (response.success || response.status === 'success') {
					if (window.rp_app && window.rp_app.always_reload_on_vehicle_selection) {
						window.location.reload();
						return;
					}

					if (response.reload_page && response.alternative_selected) {
						window.location.reload();
						return;
					}

					const isVehicleSpecificPage = currentFullPath.match(/^\/v-[^/]+/) !== null;
					const isProductPage = currentFullPath.match(/^\/parts\//) !== null;

					if (isVehicleSpecificPage) {
						if (response.alternative_selected) {
							window.location.href = alternativeCarPath;
						} else {
							window.location.href = '/';
						}
					} else if (isProductPage) {
						window.location.reload();
					} else {
						if (response.alternative_selected) {
							const alternativeWithProducts = alternativeCarPath + '/products';
							window.location.href = alternativeWithProducts;
						} else {
							window.location.href = '/';
						}
					}
				} else {
					closeIcon.classList.remove('loading');
					const spinner = icon?.querySelector('.loading-spinner');
					if (spinner) {
						spinner.remove();
					}
				}
			},
			error: function() {
				closeIcon.classList.remove('loading');
				const spinner = icon ? icon.querySelector('.loading-spinner') : null;
				if (spinner) {
					spinner.remove();
				}
			}
		});
	}

	function selectCarFromGarage(evt) {
		// Don't intercept if clicking the close icon
		if (evt.target.closest('.car-close-icon')) {
			return;
		}

		const $link = rp$(evt.currentTarget);
		if (!$link.hasClass('recent-car')) {
			return;
		}

		// If always_reload_on_vehicle_selection is true, attempt to reload
		if (window.rp_app && window.rp_app.always_reload_on_vehicle_selection) {
			// Get vehicle data from data attributes
			const year = $link.data('year');
			const make = $link.data('make');
			const model = $link.data('model');
			const trim = $link.data('trim') || '';
			const engine = $link.data('engine') || '';

			// If data is missing, let the anchor tag navigate normally
			if (!year || !make || !model) {
				return;
			}

			// Prevent default anchor behavior since we're intercepting
			evt.preventDefault();
			evt.stopPropagation();

			const variables = {
				type: 'set_parts_model',
				product: 'auto',
				year: year,
				make: make,
				model: model
			};

			if (trim) {
				variables.trim = trim;
			}
			if (engine) {
				variables.engine = engine;
			}

			if (rp_app.env && rp_app.env.page) {
				variables.page = rp_app.env.page;
			}

			// Set the vehicle via AJAX, then reload instead of navigating to the URL
			$ajax({
				method: 'post',
				url: '/ajax/vehicle-picker/select',
				data: variables,
				dataType: 'json',
				success: function() {
					// Reload the page instead of redirecting
					window.location.reload();
				},
				error: function() {
					// On error, fall back to normal navigation (server-side will set the vehicle)
					// We've already prevented default, so we need to navigate manually
					window.location.href = $link.attr('href');
				}
			});
		}
	}

	(function GarageComponent() {
		$onReady({
			rp$,
			window,
			label: 'garage_component',
			fn: function() {
				rp$('.garage.flyout').on('click', '.car-close-icon', removeCarFromGarage);
				rp$('.garage.flyout').on('click', '.recent-car', selectCarFromGarage);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
